export default "<p>\n  game-pre-bet-controls works!\n</p>\n";